import SetupMFAEnforced from '../../pages/SetupMFAEnforced'
import { useSetupMfaEnforced } from '../../hooks/useSetupMfaEnforced'
import AccountRecoveryBase from '../../components/AccountRecoveryBase'

function SetupMFAEnforcedWrapper({ user }) {
  const { errorCode, setupMfa } = useSetupMfaEnforced(user)

  return (
    <AccountRecoveryBase.Centered>
      <SetupMFAEnforced errorCode={errorCode} onSetupMfa={setupMfa} />
    </AccountRecoveryBase.Centered>
  )
}

export default SetupMFAEnforcedWrapper
